export default "<div ng-transclude></div> ";